import React from "react";
import { Text } from "@chakra-ui/react";

interface StatValueProps {
  value: number;
  format?: "percent" | "score" | "number";
  maxValue?: number;
}

const StatValue: React.FC<StatValueProps> = ({ 
  value, 
  format = "percent",
  maxValue
}) => {
  let displayValue = value.toString();
  
  if (format === "percent") {
    displayValue = `${value}%`;
  } else if (format === "score" && maxValue) {
    displayValue = `${value}/${maxValue}`;
  }

  return (
    <Text 
      fontSize="4xl" 
      fontWeight="medium" 
      lineHeight="1.1"
      color="blue.600"
      letterSpacing="-0.02em"
    >
      {displayValue}
    </Text>
  );
};

export default StatValue; 